/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mc_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste Morse — dots, dashes, and / for spaces…`)
};

const es_mc_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegue Morse — puntos, guiones e / para espacios…`)
};

const de_mc_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morse einfügen — Punkte, Striche und / für Leerzeichen…`)
};

const nl_mc_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak Morse — punten, strepen en / voor spaties…`)
};

const fr_mc_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez Morse — points, tirets et / pour les espaces…`)
};

const it_mc_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla il Morse — punti, trattini e / per gli spazi…`)
};

const pt_br2_mc_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole o Morse — pontos, travessões e / para espaços…`)
};

const pt_mc_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole Morse — pontos, traços e / para espaços…`)
};

const ja_mc_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モールス信号を貼り付け — ドット、ダッシュ、およびスペースの /…`)
};

const zh_mc_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴摩尔斯电码——点、划，以及用 / 表示空格…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mc_placeholder_decode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mc_placeholder_decode(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mc_placeholder_decode", locale)
	if (locale === "en") return en_mc_placeholder_decode(inputs)
	if (locale === "es") return es_mc_placeholder_decode(inputs)
	if (locale === "de") return de_mc_placeholder_decode(inputs)
	if (locale === "nl") return nl_mc_placeholder_decode(inputs)
	if (locale === "fr") return fr_mc_placeholder_decode(inputs)
	if (locale === "it") return it_mc_placeholder_decode(inputs)
	if (locale === "pt-BR") return pt_br2_mc_placeholder_decode(inputs)
	if (locale === "pt") return pt_mc_placeholder_decode(inputs)
	if (locale === "ja") return ja_mc_placeholder_decode(inputs)
	return zh_mc_placeholder_decode(inputs)
};